import type { AppRouteRecordRaw } from "@/types/router";
import { LAYOUT } from "@/router/constants";

const daily: AppRouteRecordRaw = {
  path: "/daily",
  name: "Daily",
  redirect: "/daily/list-report",
  component: LAYOUT,
  meta: {
    title: "日报",
  },

  children: [
    {
      path: "list-report",
      name: "AllianceListReport",
      component: () => import("@/views/alliance/list-report/index.vue"),
      meta: {
        title: "分析日报",
      },
      children: [
        {
          path: "daily-report",
          name: "AllianceDailyReport",
          component: () => import("@/views/alliance/daily-report/index.vue"),
          meta: {
            title: "日报详情",
            activeMenu: "/daily/list-report",
            keepAlive: false,
          },
        },
      ],
    },
    {
      path: "weekly-report",
      name: "WeeklyReport",
      component: () => import("@/views/alliance/weekly-report/index.vue"),
      meta: {
        title: "分析周报",
      },
      children: [
        {
          path: "detail",
          name: "WeeklyReportDetail",
          component: () => import("@/views/alliance/weekly-report/detail/index.vue"),
          meta: {
            title: "周报详情",
            activeMenu: "/daily/weekly-report",
            keepAlive: false,
          },
        },
      ],
    },
    {
      path: "monthly-report",
      name: "MonthlyReport",
      component: () => import("@/views/alliance/monthly-report/index.vue"),
      meta: {
        title: "分析月报",
      },
      children: [
        {
          path: "detail",
          name: "MonthlyReportDetail",
          component: () =>
            import("@/views/alliance/monthly-report/detail/index.vue"),
          meta: {
            title: "分析月报详情",
          },
        },
      ],
    },
    {
      path: "realtime-analysis",
      name: "RealtimeAnalysis",
      component: () => import("@/views/alliance/realtime-analysis/index.vue"),
      meta: {
        title: "实时分析",
      },
    },
    {
      path: "report-download",
      name: "ReportDownload",
      component: () => import("@/views/alliance/report-download/index.vue"),
      meta: {
        title: "报告下载",
      },
    },
  ],
};

export default daily;
